<template>
    <!-- theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <HomeViewOne ref="homeRef" :data-set="dataSet" @go-to-game-pannel="goToGamePannel" @install-app="installApp"
            @is-closed-p-w-a="isClosedPWA" @open-p-w-a-popup="openPWAPopup" @open-profile-popup="openProfilePopup"
            @reset-selected-group="resetSelectedGroup" @set-footer-ref="setFooterRef"
            @reset-show-treasure-popup="resetShowTreasureClaimPopup"
            @handle-show-treasure-popup="handleShowTreasurePopup" @set-group-list-ref="setGroupListRef"
            @set-show-p-w-a="setShowPWA" @go-to-agent="goToAgent" @go-to-game-search="goToGameSearch" />
    </div>

    <!-- theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <HomeViewTwo ref="homeRef" :data-set="dataSet" @go-to-game-pannel="goToGamePannel" @install-app="installApp"
            @is-closed-p-w-a="isClosedPWA" @open-p-w-a-popup="openPWAPopup" @open-profile-popup="openProfilePopup"
            @reset-selected-group="resetSelectedGroup" @set-footer-ref="setFooterRef" @go-to-deposit="openDepositPopup"
            @handle-show-treasure-popup="handleShowTreasurePopup" @set-group-list-ref="setGroupListRef"
            @set-show-p-w-a="setShowPWA" @go-to-agent="goToAgent"
            @reset-show-treasure-popup="resetShowTreasureClaimPopup"
            @reopen-background-recharge-popup="reopenBackgroundRechargePopup" @go-to-game-search="goToGameSearch" />
    </div>
    <div v-if="themeStore.themeIndex === 3">
        <HomeViewThree ref="homeRef" :data-set="dataSet" @install-app="installApp" @is-closed-p-w-a="isClosedPWA"
            @open-p-w-a-popup="openPWAPopup" @open-profile-popup="openProfilePopup"
            @reset-selected-group="resetSelectedGroup" @set-footer-ref="setFooterRef" @go-to-deposit="openDepositPopup"
            @handle-show-treasure-popup="handleShowTreasurePopup" @set-group-list-ref="setGroupListRef"
            @set-show-p-w-a="setShowPWA" @reset-show-treasure-popup="resetShowTreasureClaimPopup"
            @go-to-game-search="goToGameSearch" />
    </div>

    <div v-if="themeStore.themeIndex === 4" style="color: aliceblue;">
        <HomeViewFour ref="homeRef" :data-set="dataSet" @install-app="installApp" @go-to-game-pannel="goToGamePannel"
            @is-closed-p-w-a="isClosedPWA" @open-p-w-a-popup="openPWAPopup" @open-profile-popup="openProfilePopup"
            @reset-selected-group="resetSelectedGroup" @set-footer-ref="setFooterRef" @go-to-deposit="openDepositPopup"
            @handle-show-treasure-popup="handleShowTreasurePopup" @set-group-list-ref="setGroupListRef"
            @set-show-p-w-a="setShowPWA" @reset-show-treasure-popup="resetShowTreasureClaimPopup"
            @go-to-game-search="goToGameSearch" />
    </div>
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
    <div v-if="showTreasurePopup === 0 || showTreasurePopup === 6">
        <ReturnTreasureView
            v-if="userStore.returnTreasure?.return_treasure_chest_activity && !userStore.pwaShowing && userStore.isInHome && !userStore.isOpenClaimPopup"
            ref="returnTresurePopupRef" @get-deposit-claim="openDepositPopup" />
        <DailyTreasureView
            v-else-if="userStore.dailyTreasure?.state == '1' && !userStore.pwaShowing && userStore.isInHome && !userStore.isOpenClaimPopup"
            ref="dailyTresurePopupRef" @get-deposit-claim="openDepositPopup" />
        <LoginTreasureView
            v-else-if="userStore.loginTreasure.state && !userStore.pwaShowing && userStore.isInHome && !userStore.isOpenClaimPopup"
            ref="loginTresurePopupRef" @get-deposit-claim="openDepositPopup" />
        <NextdayTreasureView
            v-else-if="userStore.nextdayTreasure.state && !userStore.pwaShowing && userStore.isInHome && !userStore.isOpenClaimPopup"
            ref="nextdayTresurePopupRef" @get-deposit-claim="openDepositPopup" />
    </div>

    <BackendRecharge ref="backendRechargepRef" v-if="userStore.pendingBackendRecharge?.id && !userStore.pwaShowing"
        @get-deposit-claim="openDepositPopup" />
    <ReturnTreasureView v-if="showTreasurePopup === 1 && !userStore.pwaShowing" ref="returnTresurePopupRef"
        @get-deposit-claim="openDepositPopup" @reset-show-treasure-popup="resetShowTreasurePopup" />
    <DailyTreasureView v-if="showTreasurePopup === 2 && !userStore.pwaShowing" ref="dailyTresurePopupRef"
        @get-deposit-claim="openDepositPopup" @reset-show-treasure-popup="resetShowTreasurePopup" />
    <LoginTreasureView v-if="showTreasurePopup === 3 && !userStore.pwaShowing" ref="loginTresurePopupRef"
        @get-deposit-claim="openDepositPopup" @reset-show-treasure-popup="resetShowTreasurePopup" />
    <NextdayTreasureView v-if="showTreasurePopup === 4 && !userStore.pwaShowing" ref="nextdayTresurePopupRef"
        @get-deposit-claim="openDepositPopup" @reset-show-treasure-popup="resetShowTreasurePopup" />

</template>

<script setup lang="ts">
import { ref, onMounted, computed, onBeforeMount, onBeforeUnmount, watch } from 'vue'
import { playClickSound } from '@/utils/media'
import { getHomePageData, getPixelId } from '@/api/home'
import StatusPopup from '@/components/common/statusPopup.vue'
import { useActivityStore } from '@/stores/activity'
import { useGameStore } from '@/stores/games'
import { useUserStore } from '@/stores/user'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import type { ComponentPublicInstance } from 'vue'
import { isPastTime } from '@/utils/commonFunction'
import { Capacitor } from '@capacitor/core'
import HomeViewOne from '@/themes/themeOne/home/homeView.vue'
import HomeViewTwo from '@/themes/themeTwo/home/homeView.vue'
import HomeViewThree from '@/themes/themeThree/home/homeView.vue'
import HomeViewFour from '@/themes/themeFour/home/homeView.vue'
import { HOME_COMPONENT_ID, HomeComponent, HomeData } from './supportScript'
import { useI18n } from 'vue-i18n'
import { useThemeStore } from '@/stores/theme'
import DailyTreasureView from '../dailyTreasure/dailyTreasureView.vue'
import ReturnTreasureView from '../returnTreasure/returnTreasureView.vue'
import LoginTreasureView from '../loginTreasure/loginTreasureView.vue'
import NextdayTreasureView from '../nextdayTreasure/nextdayTreasureView.vue'
import BackendRecharge from '../backendRecharge/backendRecharge.vue'
import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'
import { initFacebookPixel, trackingEvent } from '@/utils/facebookTracking'
import { nextTick } from "vue";

interface GroupListExpose {
    setActiveItem: () => void
}
const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const themeStore = useThemeStore()
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const userStore = useUserStore()
const activityStore = useActivityStore()
const gameStore = useGameStore()
const loadingRef = ref()
const footerRef = ref<any>(null);
const homeRef = ref()
const showTreasurePopup = ref(0)
const groupList = computed(() => gameStore.groupList)
const token = computed(() => localStorage.getItem('token'))
const nextPWApopupShowTime = computed(() => userStore.PWAPopupShowTimes)
const canRecievedRewards = computed(() => userStore?.PWAConvertData?.canReceiveReward)

const groupListRefs = ref<ComponentPublicInstance<GroupListExpose>[]>([])
const deferredPrompt = ref<Event | null>(null);
const isSign = ref(token.value ? true : false)
const homeComponent = ref<HomeComponent>({
    componentsData: ""
});
const componentList = ref([]);
const componentIdsInOrderConfig = ref(HOME_COMPONENT_ID);
const isPWA = ref(false)
const isShowingPWA = ref(true)
const isOpen = computed(() => userStore?.PWAConvertData?.config?.isOpen)
const activityList = ref([]);
const homeActivityList = ref([])
const pwaInfo = ref({})
const backendRechargepRef = ref()
const isPwaClaimed = computed(() => userStore?.PWAConvertData?.isPwaClaimed)
const dataSet = computed<HomeData>(() => ({
    groupList: groupList.value,
    isSign: isSign.value,
    homeComponent: homeComponent.value,
    componentList: componentList.value,
    componentIdsInOrderConfig: componentIdsInOrderConfig.value,
    isPWA: isPWA.value,
    isShowingPWA: isShowingPWA.value
}))

const setFooterRef = (el: any) => {
    if (el) {
        footerRef.value = el;
    }
};
const goToAgent = (data: any) => {
    if (themeStore.themeIndex !== 3) {
        footerRef.value.goToAgent(data)
    }
}
const goToGamePannel = (data: any) => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') { return }
    playClickSound()
    homeRef.value.gamePoupOpen(data)
}

const openProfilePopup = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') { return }
    playClickSound()

    homeRef.value.profilePoupOpen(componentList.value)

    if (footerRef.value && typeof footerRef.value.setProfileActiveFooter === 'function') {
        footerRef.value.setProfileActiveFooter()
    } else {
        console.warn('MainFooter not ready or method missing')
    }
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const goToGameSearch = () => {
    router.push('/searchGames')
}
const getHomeConfigData = () => {
    loadingRef.value.open()
    getHomePageData().then(res => {
        loadingRef.value.close()
        // ------Theme setting Preview --------
        if (process.env.VUE_APP_PREVIEW_MODE == 'true') {
            themeStore.setThemeIndex(Number(process.env.VUE_APP_THEME))
        } else {
            // -------Theme setting only admin side ----------
            let defaultTheme = res.data?.homeConfig.find((item: any) => item.componentsName == "theme")
            if (themeStore.themeIndex != Number(defaultTheme?.componentsData)) {
                location.reload()
            }
            themeStore.setThemeIndex(Number(defaultTheme?.componentsData))

            // themeStore.setThemeIndex(4)

            // -------Theme setting from app side-------------
            // let isDefaultThemeUpdated = localStorage.getItem('isDefaultThemeUpdated')
            // if (!isDefaultThemeUpdated) {
            //     let defaultTheme = res.data?.homeConfig.find((item: any) => item.componentsName == "theme")
            //     themeStore.setThemeIndex(Number(defaultTheme?.componentsData))
            //     localStorage.setItem('isDefaultThemeUpdated', 'true')
            // }
            // ------------------------
        }

        if (themeStore.themeIndex === 1) {
            homeComponent.value = res.data?.homeConfig.find((item: any) => item.componentsName == "homes")
        } else if (themeStore.themeIndex === 2) {
            homeComponent.value = res.data?.homeConfig.find((item: any) => item.componentsName == "homes_new")
        } else if (themeStore.themeIndex === 3) {
            homeComponent.value = res.data?.homeConfig.find((item: any) => item.componentsName == "home_theme_3")
        } else if (themeStore.themeIndex === 4) {
            homeComponent.value = res.data?.homeConfig.find((item: any) => item.componentsName == "home_theme_4")
        }

        const jsonString = homeComponent.value.componentsData
        componentList.value = JSON.parse(jsonString);
        localStorage.setItem('componetList', JSON.stringify(componentList.value));
        // store activity List
        activityList.value = res.data?.activityList
        activityStore.setActivityList(activityList.value)
        //  store home float icons
        homeActivityList.value = res.data?.homeActivityList
        activityStore.setFloatIconActivities(homeActivityList.value)
        // store PWA informations
        pwaInfo.value = res.data?.domainInfo
        userStore.setPWAInfo(pwaInfo.value)

        // Footer component data setting
        if (themeStore.themeIndex === 3 || themeStore.themeIndex === 4) {
            const footerComponent = componentList.value.find((item: any) => item.component_name == "footer")
            userStore.setFooterData(footerComponent)
        }
    }).catch(err => {
        if (statusRef.value) {
            showError(err);
        }
        if (loadingRef.value) {
            loadingRef.value.close()
        }
    })
}

const installApp = async () => {
    if (deferredPrompt.value && 'prompt' in deferredPrompt.value) {
        const promptEvent = deferredPrompt.value as any
        promptEvent.prompt();
        deferredPrompt.value = null;
    }
}
const isClosedPWA = async (value: any) => {
    isShowingPWA.value = value

}
const setShowPWA = async (value: any) => {
    return value
}

const openPWAPopup = () => {
    if (canRecievedRewards.value === 1) {
        if (isPwaClaimed.value === 1) {
            homeRef.value.pwaStatusPoupOpen(t('activityStatus.completed'))
        } else {
            homeRef.value.pwaStatusPoupOpen(t('rewards.notActivated'))
        }
    } else if (isOpen.value === 0) {
        homeRef.value.pwaStatusPoupOpen(t('rewards.notActivated'))
    } else {
        homeRef.value.pwaPoupOpen()
    }
}

const openDepositPopup = () => {
    if (themeStore.themeIndex === 2) {
        footerRef.value.goToPath('/sd-carteira', 2)
    }
    if (themeStore.themeIndex === 3) {
        localStorage.setItem('footerPopupOpen', String(2))
        router.push('/sd-topup')
    }
}

const handleShowTreasurePopup = (path: any) => {
    if (path === 'return_treasure_chest') {
        showTreasurePopup.value = 1
    }
    if (path === 'daily_treasure_chest') {
        showTreasurePopup.value = 2
    }
    if (path === 'login_treasure_chest') {
        showTreasurePopup.value = 3
    }
    if (path === 'next_day_treasure_chest') {
        showTreasurePopup.value = 4
    }
    if (path === 'admin_recharge') {
        backendRechargepRef.value.openPopup()
    }
}
const reopenBackgroundRechargePopup = () => {
    backendRechargepRef.value.openPopup()
}
const resetShowTreasurePopup = () => {
    showTreasurePopup.value = 0
}
const resetShowTreasureClaimPopup = () => {
    showTreasurePopup.value = 6
}

const getRefCode = () => {
    const code = route.query.ref;
    if (code) {
        localStorage.setItem('inviteRefCode', code as string);
    }
}

const getFaceBookTrackingPixelId = async (codeVal: any): Promise<void> => {
    let code = codeVal
    let data = {
        channelCode: code
    }
    try {
        const res = await getPixelId(data)
        const pixelID = res.data.pixelId
        const channel_code = res.data.channelCode
        if (pixelID) {
            localStorage.setItem('fbPixelId', pixelID)
        }
        if (channel_code) {
            localStorage.setItem('fbChannelCode', channel_code)
        }
        initFacebookPixel()
    } catch (err) {
        if (statusRef.value) {
            showError(err as any);
        }
    }
}

onMounted(async () => {
    showTreasurePopup.value = 5 // default index

    getHomeConfigData()
    gameStore.getGameGroupListData()

    getRefCode()

    if (route.query.ref) {
        await getFaceBookTrackingPixelId(route.query.ref as string)
    } else {
        const channel_code = localStorage.getItem('fbChannelCode');
        if (!channel_code) {
            await getFaceBookTrackingPixelId('')
        }
    }

    trackingEvent('PageView')

    if (token.value) {
        userStore.getInfo()
    }
    // PWA install prompt
    window.addEventListener('beforeinstallprompt', (e: Event) => {
        e.preventDefault()
        deferredPrompt.value = e
    });
    window.addEventListener('appinstalled', () => {
        location.reload();
        sessionStorage.setItem('openPromotionPopup', 'true');
    });
    pwaDataBinding()
    localStorage.setItem('redirectFromCalim', '')
})
const setGroupListRef = (el: any) => {
    if (el && !groupListRefs.value.includes(el)) {
        groupListRefs.value.push(el)
    }
}
const resetSelectedGroup = () => {
    groupListRefs.value.forEach(ref => {
        ref?.setActiveItem?.()
    })
}

const pwaDataBinding = () => {
    if (token.value) {
        if (nextPWApopupShowTime.value) {
            if (isPastTime(nextPWApopupShowTime.value)) {
                homeRef.value.pwaPoupOpen()
            } else {
                userStore.setPwaShowing(false)
            }
        } else {
            homeRef.value.pwaPoupOpen()
        }
    }
}

watch(
    () => userStore.PWAConvertData,
    () => {
        pwaDataBinding()
    }
)

onBeforeMount(() => {
    const isNativeApp = Capacitor.isNativePlatform();
    isPWA.value = window.matchMedia('(display-mode: standalone)').matches ||
        (window.navigator.standalone === true) ||
        document.referrer.includes('android-app://');
})
onBeforeUnmount(() => {
    groupListRefs.value = []
})
</script>